import { BaremosDto } from 'src/app/shared/dtos';
import { Baremos } from '@app/questionnaire/interfaces';

/**
 * Baremos model
 */

/**
 * Baremos manager
 */
export class BaremosManager {
	/**
	 * Baremos array
	 */
	baremos: Baremos[] = [];

	/**
	 * Value to rest import
	 */
	valueRestimport: number;

	/**
	 * Baremos manager constructor. Sets the baremos
	 *
	 * @param data data. BaremosDto type.
	 */
	constructor(data: BaremosDto) {
		/**
		 * id map
		 */
		const ids = new Map();

		for (const item of data.condiciones) {
			this.baremos.push({
				id: item.idParametro,
				ingresoMonoparental: 0,
				ingresoDiscapacidad: 0,
				ingresoDiscapacidadMonoparental: 0,
				ingresoNoMonoparental: 0,
				ingresoVencidoMonoparental: 0,
				ingresoVencidoDiscapacidad: 0,
				ingresoVencidoDiscapacidadMonoparental: 0,
				ingresoVencidoNoMonoparental: 0,
				ingresoInfanciaMonoparental: 0,
				ingresoInfanciaDiscapacidad: 0,
				ingresoInfanciaDiscapacidadMonoparental: 0,
				ingresoInfanciaNoMonoparental: 0,
				condicion: item.condiciones,
				nombre: item.nombre,
			});
			ids.set(item.idParametro, this.baremos.length - 1);
		}

		for (const item of data.ingresoAnual) {
			if (ids.has(item.indIngresoAnual)) {
				const index = ids.get(item.indIngresoAnual);
				this.baremos[index].ingresoMonoparental = item.ingresoMonoparental;
				this.baremos[index].ingresoDiscapacidad = item.ingresoDiscapacidad;
				this.baremos[index].ingresoDiscapacidadMonoparental = item.ingresoDiscapacidadMonoparental;
				this.baremos[index].ingresoNoMonoparental = item.ingresoNoMonoparental;
			}
		}

		for (const item of data.ingresoAnualVencido) {
			if (ids.has(item.indIngresoAnualVencido)) {
				const index = ids.get(item.indIngresoAnualVencido);
				this.baremos[index].ingresoVencidoMonoparental = item.ingresoMonoparental;
				this.baremos[index].ingresoVencidoDiscapacidad = item.ingresoDiscapacidad;
				this.baremos[index].ingresoVencidoDiscapacidadMonoparental = item.ingresoDiscapacidadMonoparental;
				this.baremos[index].ingresoVencidoNoMonoparental = item.ingresoNoMonoparental;
			}
		}

		for (const item of data.ingresoInfancia) {
			if (ids.has(item.indIngresoInfancia)) {
				const index = ids.get(item.indIngresoInfancia);
				this.baremos[index].ingresoInfanciaMonoparental = item.ingresoMonoparental;
				this.baremos[index].ingresoInfanciaDiscapacidad = item.ingresoDiscapacidad;
				this.baremos[index].ingresoInfanciaDiscapacidadMonoparental = item.ingresoDiscapacidadMonoparental;
				this.baremos[index].ingresoInfanciaNoMonoparental = item.ingresoNoMonoparental;
			}
		}

		this.valueRestimport = +data.formula.valor;
	}
}
